<template>
    <main class="main-content">
        <page-title id="package-header" background="/assets/img/slide-03.jpg" :title="$t('steelkeg.title')"></page-title>


        <section class="section">
            <div class="columns">
                <div class="column is-4 has-text-centered">
                    <img src="/assets/img/acciaio.jpg" alt="MonVin Fusto Acciaio">
                </div>
                <div class="column is-8 has-text-justified is-flex flex-column">
                    <p v-t="'steelkeg.section1.paragraphs.1'"></p>
                    <p v-t="'steelkeg.section1.paragraphs.2'"></p>

                    <p v-t="'steelkeg.section1.paragraphs.3'"></p>
                    <p class="mt-auto"><strong v-t="'steelkeg.section1.paragraphs.4'"></strong></p>
                </div>
            </div>
        </section>

        <parallax-section background="/assets/img/toasting-sparkling.jpg?id=45124741"></parallax-section>

        <section class="section package-icons">
            <div class="columns is-multiline is-mobile my-3">
                <div class="column is-4-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/hq-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'steelkeg.advantages.1'"></p>
                </div>
                <div class="column is-4-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/clock-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'steelkeg.advantages.2'"></p>
                </div>
                <div class="column is-4-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/cloud-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'steelkeg.advantages.3'"></p>
                </div>
                <div class="column is-4-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/saving-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'steelkeg.advantages.4'"></p>
                </div>
                <div class="column is-4-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/barel-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'steelkeg.advantages.5'"></p>
                </div>
                <div class="column is-4-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/like-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'steelkeg.advantages.6'"></p>
                </div>
            </div>
        </section>

        <parallax-section background="/assets/img/package-advantages.jpg?id=45124741">
            <h2 class="section-title" v-t="'steelkeg.section2.title'"></h2>
        </parallax-section>

        <section class="section">
            <div class="columns">
                <div class="column is-4 is-hidden-mobile">
                    <img src="/assets/img/bottles.jpg?id=45124741">
                </div>
                <div class="column is-4 is-hidden-mobile">
                    <img src="/assets/img/stopper.jpg?id=45124741">
                </div>
                <div class="column is-4 is-flex-tablet has-items-center">
                    <ul class="fa-ul advantages-list">
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'steelkeg.section2.advantages.1'"></span></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'steelkeg.section2.advantages.2'"></span></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'steelkeg.section2.advantages.3'"></span></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'steelkeg.section2.advantages.4'"></span></li>
                    </ul>
                </div>
            </div>
        </section>

        <collection-router></collection-router>
    </main>
</template>
<script>
    import PageTitle from './../components/PageTitle'
    import ParallaxSection from './../components/ParallaxSection'
    import CollectionRouter from './../components/CollectionRouter'

    export default {
        components: {
            PageTitle,
            ParallaxSection,
            CollectionRouter
        },
        metaInfo() {
            return {
                title: this.$t('seo.keg.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.keg.title')},
                    {name: 'description', content: this.$t('seo.keg.description')}
                ]
            }
        }
    }
</script>